// extracted by mini-css-extract-plugin
export default {"container":"container-FRbmc","item":"item-wMdM7"};